// components/CustomCard.tsx
import React from "react";
import Image from "next/image";
import ImageWithLoader from "./imageWithLoader/ImageWithLoader";
import { optimizeImageUrl } from "@/app/utils/optimizeImageUrl";
import CloseIcon from "./icons/CloseIcon";
import CustomButton from "./CustomButton";

interface MasterPlanCardProps {
	title: string;
	logoSrc?: string;
	hasCloseIcon?: boolean;
	closeAction?: () => void;
	button1Text?: string;
	button1Action?: () => void;
	button2Text?: string;
	button2Action?: () => void;
	imageSrc: string;
	customClass?: string;
	ContentBg?: string;
	ZoneID?: string;
	isZone?: boolean;
	isUnit?: boolean;
	isFacilities?: boolean;
	neigborhoodDetailsPage?: boolean;
	showFacilitiesBtn?: boolean;
	optimizedImage?: boolean;
}

const MasterPlanCard: React.FC<MasterPlanCardProps> = ({
	title,
	logoSrc,
	hasCloseIcon,
	closeAction,
	button1Text,
	button1Action,
	button2Text,
	button2Action,
	imageSrc,
	customClass,
	ContentBg,
	ZoneID,
	isZone,
	isUnit,
	isFacilities,
	neigborhoodDetailsPage,
	showFacilitiesBtn,
	optimizedImage,
}) => {
	return (
		<div className={`w-full  bg-white overflow-hidden relative ${customClass}`}>
			{/* Logo */}
			<div className="absolute top-0 left-0 w-full h-full">
				{logoSrc && (
					<div className="relative h-[3.5rem]">
						<div className="absolute top-0 left-0 z-[5] py-3 px-4 bg-oSilver-100 w-[5.5rem] h-[3.5rem]">
							<Image
								src={
									optimizedImage
										? optimizeImageUrl(logoSrc, { width: 128, quality: 75 })
										: logoSrc
								}
								alt="Logo"
								width={60}
								height={60}
								className="object-contain h-[100%]"
							/>
						</div>
					</div>
				)}

				{/* Close Icon */}
				{hasCloseIcon && (
					<button
						className="absolute top-0 right-0  z-[5] w-[3.25rem] h-[3.25rem] flex items-center justify-center bg-oCustomWhite"
						onClick={closeAction}
					>
						<CloseIcon color="#091A32" />
					</button>
				)}
			</div>

			{/* Background Image */}
			<div className="relative w-full h-[13rem]">
				{optimizedImage ? (
					<ImageWithLoader
						src={imageSrc}
						alt={title || ""}
						sizeVariant="twoCol"
						quality={75}
					/>
				) : (
					<Image
						src={imageSrc}
						alt={title || ""}
						layout="fill"
						objectFit="cover"
					/>
				)}
			</div>

			{/* Content */}
			<div className={`relative p-4 justify-start ${ContentBg} `}>
				<div className="flex items-center gap-3 ">
					{/* {isFacilities && (
						<div className="img-wrapper relative w-[2.6rem] h-[2.6rem]">
							<Image
								src={"/images/neighborhoods/popupCard/logo.png"}
								alt="img"
								fill
								objectFit="contain"
							/>
						</div>
					)} */}
					<h3
						className={`text-bodyL  text-oBlue-150 ${
							isFacilities ? "" : "mb-2"
						} `}
					>
						{title}
					</h3>
				</div>

				{/* Buttons */}
				<div className="flex justify-between gap-2 mt-6">
					{isZone && (
						<div className="w-[50%]">
							<CustomButton
								text={button1Text}
								hasIcon
								style="blue"
								customClass={`flex-1 ${
									!neigborhoodDetailsPage ? "w-[-webkit-fill-available]" : ""
								}`}
								action={button1Action}
								url={ZoneID}
							/>
						</div>
					)}
					{(isZone || isUnit || showFacilitiesBtn) && (
						<div className="w-[50%]">
							<CustomButton
								text={button2Text}
								hasIcon
								style={
									isFacilities
										? "blue"
										: neigborhoodDetailsPage
										? "blue"
										: "grey"
								}
								url={ZoneID}
								customClass={`flex-1 ${
									!neigborhoodDetailsPage ? "w-[-webkit-fill-available]" : ""
								}`}
								action={button2Action}
							/>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default MasterPlanCard;
